export const ON_LOAD_WM_PAYMENTS_SUCCESS = "ON_LOAD_WM_PAYMENTS_SUCCESS";
export const SET_WM_PAYMENTS_SORT = "SET_WM_PAYMENTS_SORT";
export const SET_WM_PAYMENT_LIST_DATE_RANGE = "SET_WM_PAYMENT_LIST_DATE_RANGE";
